let callback;

const handle = (token) => {
	window.jQuery('#recaptchaToken').val(token);
	callback(token);
};

const execute = (resultCallback) => {
	if (!window.hasOwnProperty('grecaptcha')) {
		console.error(new Error("Google Recaptcha isn't loaded!"));
		return;
	}
	callback = resultCallback;
	grecaptcha.execute();
};

const reset = () => {
	if (!window.hasOwnProperty('grecaptcha')) {
		console.error(new Error("Google Recaptcha isn't loaded!"));
		return;
	}
	grecaptcha.reset();
};

const getToken = () => {
	return window.jQuery('#recaptchaToken').val();
};

window.handleRecaptcha = handle;

module.exports = {
	execute,
	reset,
	getToken
};
